import { Component, Input, Optional } from '@angular/core';
import { OrgIndividualTeamsComponent } from '../../org-individual-teams/org-individual-teams.component';
import { OrgIndividualSessionsComponent } from '../../org-individual-sessions/org-individual-sessions.component';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-teams-input-popup',
  templateUrl: './teams-input-popup.component.html',
  styleUrls: ['./teams-input-popup.component.scss']
})
export class TeamsInputPopupComponent {

  @Input() popupType;
  userDetail = [1];
  newUserEmail = '';
  newUserLstName = '';
  newUserFstName = '';
  loading = 3;

  // New team creation
  teamMode: 'manual' | 'criteria' = 'manual';
  criteria: string = '';
  numTeams: number = 3;
  variant: number = 0;
  criteriaLoading = false;

  constructor(
    @Optional() public orgIndivTeams: OrgIndividualTeamsComponent,
    public orgIndivSesn: OrgIndividualSessionsComponent,
    public http: HttpClient
  ) {}

  public close() {
    if (this.orgIndivTeams) {
      this.orgIndivTeams.modalSvc.createNewTeamBtn = false;
      this.orgIndivTeams.modalSvc.showTeamModal = false;
    }
    this.teamMode = 'manual';
    this.criteria = '';
    this.numTeams = 3;
    this.variant = 0;
    this.criteriaLoading = false;
    if (this.popupType == 'team') {
      $('.team-modal').css('display', 'none');
    } else if (this.popupType == 'session') {
      $('.session-modal').css('display', 'none');
    } else if (this.popupType == 'teamMate') {
      $('.team-modal').css('display', 'none');
    }
  }

  increaseUserDetail() {
    this.userDetail.push(1);
  }

  public generateTeamsByCriteria() {
    if (!this.criteria || !this.numTeams || this.numTeams < 1) return;

    this.criteriaLoading = true;
    const payload: any = {
      criteria: this.criteria,
      num_teams: this.numTeams,
      ...(this.variant != null && this.variant !== 0 ? { variant: this.variant } : {})
    };

    this.http.post(
      `${environment.profileURL}/api/v1/roster_organizations/${this.orgIndivTeams?.id}/create_teams_with_criteria`,
      payload
    ).subscribe(
      (res: any) => {
        this.criteriaLoading = false;
        const teamCount = res?.teams?.length || 0;
        const criteriaLabel = this.criteria.replace(/_/g, ' ');
        this.close();
        $('.team-modal').css('display', 'none');
        this.orgIndivTeams?.getTeamsData();
        Swal.fire({
          title: 'Teams Generated!',
          text: `${teamCount} teams were created using ${criteriaLabel}.`,
          icon: 'success',
          timer: 3000,
          showConfirmButton: false,
          customClass: { container: 'swal-above-modal' }
        });
      },
      (err) => {
        this.criteriaLoading = false;
        this.close();
        $('.team-modal').css('display', 'none');
        const errors = err?.error?.errors;
        const errorText = Array.isArray(errors)
          ? [...new Set(errors)].join('<br>')
          : (errors || err?.error?.error || 'Failed to generate teams. Please try again.');
        Swal.fire({
          title: 'Error',
          html: `<p style="word-break:break-word;margin:0">${errorText}</p>`,
          icon: 'error',
          confirmButtonColor: '#5cb85c',
          customClass: { container: 'swal-above-modal' }
        });
      }
    );
  }

  addRosterNoProfileMem() {
    let email = {
      'email': this.newUserEmail,
      'first_name': this.newUserFstName,
      'last_name': this.newUserLstName
    };
    this.http.post(
      `${environment.profileURL}/api/v1/roster_organizations/${this.orgIndivTeams?.id}/add_member.json`,
      email
    ).subscribe(
      (res: any) => {
        let newUserData = {
          'default_identity': { 'email': this.newUserEmail },
          'non_admin_unassgined_teams_count': 0
        };
        newUserData.default_identity = res.memberships[res.memberships.length - 1];
        if (this.orgIndivTeams?.teamsData?.members) this.orgIndivTeams.teamsData.members.push(newUserData);
        this.close();
        if (this.orgIndivTeams) this.orgIndivTeams.totalMembers = parseInt(this.orgIndivTeams.totalMembers) + 1;
        this.newUserEmail = '';
        this.newUserFstName = '';
        this.newUserLstName = '';
        Swal.fire({ title: 'Nice!', text: 'Member added successfully.', icon: 'success', timer: 2000, showConfirmButton: false });
      },
      () => {
        Swal.fire({ title: 'Oops!', text: 'Something went wrong!', icon: 'error', timer: 2000, showConfirmButton: false });
      }
    );
  }
}
